import { useState, useEffect } from "react";
import { useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion"

import productApi from "../../api/productApi";
import useMount from '../../hooks/useMount';
import LoadingComponent from "../Commons/LoadingComponent";
import AlertModal from "../Commons/AlertModal";
import ConfirmModal from "../Commons/ConfirmModal";
import BackButton from "../Commons/BackButton";
import useAccess from "../../hooks/useAccess";
import useLog from "../../hooks/useLog";
import { setCurrentNavigation } from "../../slices/navigationSlice";
import ProductFileDisplay from "../ProductFile/ProductFileDisplay";

import { getLabel } from "../../tools/Dictionary";

import "./Troubleshoot.css";

const TroubleshootFile = (props) => {

  //Logs
  const { logPageView } = useLog();

  //Query
  let [searchParam] = useSearchParams();

  //Navigation
  const Navigate = useNavigate();


  //Props
  const IsDesktop = props.IsDesktop;

  //Redux
  const Dispatch = useDispatch();
  const Access = useAccess(["Trouble"]);

  //State
  const [product, setProduct] = useState(undefined);
  const [loading, setLoading] = useState(true);
  const [alert, setAlert] = useState({
    Title: "",
    Message: "",
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });
  const [confirm] = useState({
    Title: "",
    Message: "",
    Cancel: "",
    onCancel: () => void 0,
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });

  useMount(() =>
  {
    Dispatch(setCurrentNavigation("TroubleProductFile"));
    loadData();
  }, []);

  useEffect(() =>
  {
    if (product)
      logPageView("Troubleshoot File", { productId: product._id, productCode: product.code });
  }, [product]);

  const loadData = async (_showLoading = true) =>
  {

    try
    {

      let currentProduct = {
        _id: searchParam.get('product'),
      };


      //Get product data from the storage
      const storageProduct = JSON.parse(localStorage.getItem("product"));
        

      if (_showLoading)
      {
        setLoading(true);
      }


      //If no storage data, if they product is not the same or if it has been loaded more than 10 minutes ago, load from the api. Otherwise load from storage.
      if (!storageProduct || storageProduct._id != currentProduct._id || new Date().getTime() - storageProduct.timestamp >= 600000){

        let [productResponse] = await Promise.all([
          productApi.getProduct(currentProduct._id)
        ]);

        if (!productResponse.Success) throw new Error(productResponse.Error.label);

        setProduct(productResponse.Data);

      }else {

        setProduct(storageProduct);

      }



      setLoading(false);

    } catch (err)
    {

      Navigate("/troubleshoot");

      setLoading(false);

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });

    }

  };

  if (!Access.canRead)
    return (
      <div className="page_cont">
        <div className="page_message_text">
          {getLabel("App", "Access Denied: You don't have...")}
        </div>
      </div>
    );



  return (
    <div className="page_body_cont">
      <LoadingComponent
        display={loading}
        label={getLabel("App", "Loading")}
      />
      <AlertModal
        Title={alert.Title}
        Message={alert.Message}
        Confirm={alert.Confirm}
        onConfirm={alert.onConfirm}
        Display={alert.Display}
      />
      <ConfirmModal
        Display={confirm.Display}
        Title={confirm.Title}
        Message={confirm.Message}
        Cancel={confirm.Cancel}
        onCancel={confirm.onCancel}
        Confirm={confirm.Confirm}
        onConfirm={confirm.onConfirm}
      />
      <BackButton
        Hide={IsDesktop}
      />
      <div className="troubleshoot_title_cont" >
        <div className="troubleshoot_title_col" style={{ width: "40%", alignItems: "flex-end" }}>
        </div>
        <div className="troubleshoot_title_col troubleshoot_title_text" style={{ width: "40%" }}>{getLabel("TroubleshootProduct", "Documentation")}</div>
        <div className="troubleshoot_title_col" style={{ width: "40%" }}></div>
      </div>
      {!loading && product && 
      <div className="troubleshoot_product_cont">
        {product.productFile.map((f, indexF) => (
          <motion.div className="troubleshoot_product_row" 
            style={{ willChange: "none" }}
            variants={{ hidden: { opacity: 0, scale: 0.95 }, show: { opacity: 1, scale: 1 } }}
            initial="hidden"
            animate="show"
            key={indexF}
          >
            <ProductFileDisplay
              Data={f}
              Style={{ justifyContent: "flex-start" }}
              ShowDownload={true}
            />
          </motion.div>
        ))}
      </div>
      }
    </div>
  );

};

export default TroubleshootFile